module.exports = __webpack_public_path__ + "img/play2.779b8c79.svg";